module.exports = __webpack_public_path__ + "static/advantage_product3-006a0054ee3702cc2d59850606d815e9.jpg";